import {ApiApartmentsService, ApiCuratorService, ApiFeaturesService} from "../../../../../shared/api";
import {config} from "../../../../../shared/config/config";

export const mediaUrl = (file) => `${config.API_HOST}/media/${String(file).split('/').map(encodeURIComponent).join('/')}`

export const statusColor = (status) => ({
  'Свободно': 'green',
  'Забронировано': 'gold',
  'Продано': 'default',
  'Скрыта': 'purple',
})[status] || 'blue'

// every complex card (id, name), loaded once for the filter and the placement select
let complexesPromise = null
export const loadComplexes = () => {
  if (!complexesPromise) {
    complexesPromise = ApiApartmentsService.fetchComplexNames()
      // the developer filters the complexes in the flat editor, the coordinates centre its view map
      .then(({data}) => (Array.isArray(data) ? data : data.items || []).map(({id, name, developer, latitude, longitude}) => ({
        id, name, developer: developer ? String(developer).trim() : '', latitude, longitude,
      })))
      .catch((error) => {
        complexesPromise = null
        throw error
      })
  }
  return complexesPromise
}

// a card added from the flat editor joins the loaded list (the section's filter and the next flat see it)
export const rememberComplex = (card) => {
  if (!complexesPromise) return
  complexesPromise = complexesPromise.then((list) => (list.some((c) => c.id === card.id) ? list : [...list, card]))
}

export const complexOptions = (complexes) => complexes.map(({id, name}) => ({value: id, label: name}))

// the form description and its value lists: loaded once per page
let referencesPromise = null
export const loadReferences = () => {
  if (!referencesPromise) {
    referencesPromise = Promise.all([
      ApiApartmentsService.fetchMeta(),
      ApiCuratorService.fetchCurators(),
      ApiApartmentsService.fetchSelections(),
      ApiFeaturesService.fetchOptions(),
    ]).then(([meta, curators, selections, features]) => ({
      meta: meta.data,
      curators: (curators.data || []).map((c) => ({value: String(c.id), label: [c.lastName, c.name, c.patronymic].filter(Boolean).join(' ')})),
      selections: (selections.data || []).map((s) => ({value: s.id, label: s.name || `Подборка ${s.id}`})),
      // «Особенности» by id: the portal's own tags first; hidden ones are marked
      features: (features.data || []).map((f) => ({
        value: f.id,
        label: `${f.name}${f.own ? ' · метка портала' : ''}${f.hidden ? ' · скрыта' : ''}`,
      })),
    })).catch((error) => {
      referencesPromise = null
      throw error
    })
  }
  return referencesPromise
}
